<template>
    <Accordion header="Learn how we use your personal information">
        <div class="accordion-body-subtitle">
            <strong class="mr-05">Types of information we collect and save:</strong>
        </div>
        <div class="column-layout">
            <div class="first-column-information-list">
                <div>First name</div>
                <div>Middle name</div>
                <div>Family name</div>
                <div>Date of birth</div>
            </div>
            <div class="second-column-information-list">
                <div>Address</div>
                <div>Mobile number</div>
                <div>Driver licence card details</div>
                <div>Medicare card details</div>
            </div>
        </div>
        <div class="accordion-body-subtitle">
            <strong class="mr-05 accordion-body-subtitle">How we user your information</strong>
        </div>
        <div>We pre-fill your personal details in forms that you complete online.</div>
        <div class="accordion-body-subtitle">
            <strong class="mr-05 accordion-body-subtitle">Services that may use your information</strong>
        </div>
        <ul>
            <li>Active Kids</li>
            <li>Creative Kids</li>
            <li>Seniors Energy Rebate</li>
            <li>Energy Switch</li>
        </ul>
        <p>
            Our
            <a
                id="privacy-link"
                class="is-internal"
                href="https://www.service.nsw.gov.au/privacy"
                target="_blank"
                @click="triggerGA('Privacy Link', 'Click')"
            >
                privacy statement
            </a> explains how we collect and use information.
        </p>
    </Accordion>
</template>

<script>
    import Accordion from './Accordion'
    import gaTrackerAdapter from '../utils/gaTrackerAdapter'

    export default {
        name: 'LearnMoreAccordion',
        components: { Accordion },
        methods: {
            triggerGA(category, action, label = window.location.href) {
                gaTrackerAdapter.trackEvent(category, action, label)
            }
        }
    }
</script>

<style lang="css" src="../../node_modules/@servicensw/constants/constants.css"></style>
<style lang="css" scoped src="../../node_modules/@servicensw/base/dist/base.css"></style>
<style scoped lang="scss">

    .is-internal {
        padding: 0;
    }

    .first-column-information-list {
        line-height: 1.8rem;
    }

    .second-column-information-list {
        margin-left: 2rem;
        padding-left: 2rem;
        border-left: 1px solid silver;
        line-height: 1.8rem;
    }

    .column-layout {
        display: flex;
    }

    .accordion-body-subtitle {
        padding-top: 2rem;
        padding-bottom: 1rem;
        &:first-of-type {
            padding-top: 0;
        }
    }

    ul {
        margin-top: 0;
        margin-bottom: 0;
        li {
            padding: 0;
            background: none;
            font-size: 1rem;
            margin-top: 0.5rem;
            margin-bottom: 0.5rem;
        }
    }
</style>
